import request from '@/utils/request'

export default {
    userInfo: function (form) {
        if (!form) form = {}
        return request({
            url: 'user/info',
            method: 'post',
            data: form
        })
    },
    login: function (form) {
        if (!form) form = {}
        return request({
            url: '/user/login',
            method: 'post',
            data: form
        })
    },
    inviteUser: function (inviteCode) {
        return request({
            url: '/user/inviteUser',
            method: 'get',
            params: {inviteCode: inviteCode}
        })
    },
    register: function (form) {
        if (!form) form = {}
        return request({
            url: '/user/register',
            method: 'post',
            data: form
        })
    },
    newPass: function (form) {
        if (!form) form = {}
        return request({
            url: '/user/newPass',
            method: 'post',
            data: form
        })
    },
    bindPhone: function (form) {
        if (!form) form = {}
        return request({
            url: '/user/bindPhone',
            method: 'post',
            data: form
        })
    },
    show: function (form) {
        if (!form) form = {}
        return request({
            url: '/user/show',
            method: 'post',
            data: form
        })
    },
    group: function (form) {
        if (!form) form = {}
        return request({
            url: '/user/group',
            method: 'post',
            data: form
        })
    },
    groupDown: function (form) {
        if (!form) form = {}
        return request({
            url: '/user/groupDown',
            method: 'post',
            data: form
        })
    },
    jobItemPriceList: function (form) {
        if (!form) form = {}
        return request({
            url: '/user/jobItemPriceList',
            method: 'post',
            data: form
        })
    },
    jobItemPriceSave: function (form) {
        if (!form) form = {}
        return request({
            url: '/user/jobItemPriceSave',
            method: 'post',
            data: form
        })
    },
    updatePerson(form){
        if (!form) form = {}
        return request({
            url: '/user/update',
            method: 'post',
            data: form
        })
    },
    cashBankBind(form){
        if (!form) form = {}
        return request({
            url: '/user/cashBankBind',
            method: 'post',
            data: form
        })
    },
}
